import type { FunctionComponent } from 'react';
import Button, { BUTTON_TYPES } from '../../shared-components/Button/Button';
import env from '../../utils/env';
import NoOrders from '../NoOrders';
import Order from './Order';
import * as styles from './styles.module.scss';

const SUPPORT_LINK = `https://support.${env.hostname}/`;

type OrdersListProps = {
  orders: {
    billingDate: string;
    orderTotalInCents: number;
  }[];
  isDesktop: boolean;
  onClickAllInvoices: () => void;
  onClickOrderDetails: () => void;
  trackOrderViewed: () => void;
  trackShipment: () => void;
};

const OrdersList: FunctionComponent<OrdersListProps> = ({
  orders = [],
  isDesktop,
  onClickAllInvoices,
  onClickOrderDetails,
  trackOrderViewed,
  trackShipment,
}) => (
  <div className={styles.ordersList} data-testid="orders-list-container">
    <div className={styles.header}>
      <div className={styles.headerTitle} data-testid="orders-list-header">
        <h1>Orders</h1>
        <p>
          Orders may take a few days to show in your account, but you can view your invoice
          immediately by clicking ALL INVOICES to confirm your recent purchase. If you have any
          questions in the meantime, feel free to check out our FAQ or reach out to{' '}
          <a href={SUPPORT_LINK} rel="noreferrer" target="_blank" data-testid="customer-care-link">
            {' '}
            Customer Care
          </a>
          .
        </p>
      </div>
      <Button
        buttonType={BUTTON_TYPES.PRIMARY_INVERSE}
        className={styles.button}
        onClick={onClickAllInvoices}
        dataTestId="all-invoices-btn"
      >
        All Invoices
      </Button>
    </div>
    <div className={styles.orders} data-testid="orders-container">
      {orders.length === 0 && <NoOrders />}
      {orders.map((order, index) => (
        <Order
          key={order.billingDate + order.orderTotalInCents}
          order={order}
          index={index}
          isDesktop={isDesktop}
          onClickOrderDetails={onClickOrderDetails}
          trackOrderViewed={trackOrderViewed}
          trackShipment={trackShipment}
        />
      ))}
    </div>
  </div>
);

export default OrdersList;
